var moduleMap = {
	"./wof": () => {
		return __webpack_require__.e(/* __federation_expose_wof */ 3896).then(() => (() => ((__webpack_require__(5944)))));
	},
	"./VehicleBar": () => {
		return __webpack_require__.e(/* __federation_expose_VehicleBar */ 1407).then(() => (() => ((__webpack_require__(46248)))));
	},
	"./VehicleApplicator": () => {
		return __webpack_require__.e(/* __federation_expose_VehicleApplicator */ 9631).then(() => (() => ((__webpack_require__(58056)))));
	},
	"./WaysOfFindingSection": () => {
		return __webpack_require__.e(/* __federation_expose_WaysOfFindingSection */ 2299).then(() => (() => ((__webpack_require__(48116)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope, remoteEntryInitOptions) => {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};


// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});